import { useSSOMarketingPopupContext } from "./PopupProvider";
import { Marquee } from "../marquee";
import { useMemo } from "react";
import { classNames } from "../helpers";
import { FocusedComponentType, FocusedVia } from "./types";
import { getHtmlBannerText, getTextLength } from "./utils";

const OPTIONS = {
  loop: true,
};

export const PopupTopBanner = () => {
  const {
    popup: {
      banner: {
        enabled,
        items,
        backgroundColor: commonBackgroundColor,
        textColor: commonTextColor,
      },
    },
    overRides,
  } = useSSOMarketingPopupContext();

  if (!enabled) return <></>;

  if (items.length === 1) {
    const item = items[0];
    const backgroundColor = item?.backgroundColor || commonBackgroundColor;
    const textColor = item?.textColor || commonTextColor;
    return (
      <div
        className="ui-w-full ui-text-center"
        onClick={() =>
          overRides?.setFocusedComponent?.({
            type: FocusedComponentType.BANNER,
            via: FocusedVia.POPUP
          })
        }
      >
        <p
          style={{
            backgroundColor,
            color: textColor,
          }}
          className={classNames(
            "ui-w-full ui-text-xs ui-leading-[18px] ui-font-semibold ui-py-[3px] ui-px-2 ui-text-center ",
            overRides?.focusedComponent?.type === FocusedComponentType.BANNER
              ? "ui-border ui-border-primary-dark ui-shadow-xl"
              : "",
            getTextLength(item?.htmlTextString || "") === 0 ? "h-[35px]" : ""
          )}
          dangerouslySetInnerHTML={{
            __html: getHtmlBannerText(
              item?.htmlTextString || "",
              overRides,
              "banner"
            ),
          }}
        />
      </div>
    );
  }

  const slides = useMemo(() => {
    return items.map((item, index) => {
      const backgroundColor = item.backgroundColor || commonBackgroundColor;
      const textColor = item.textColor || commonTextColor;
      return (
        <p
          key={index}
          style={{
            backgroundColor,
            color: textColor,
          }}
          className="ui-w-full ui-text-xs ui-leading-[18px] ui-font-semibold ui-py-[3px] ui-px-2 ui-border-none"
          dangerouslySetInnerHTML={{ __html: item?.htmlTextString || "" }}
        />
      );
    });
  }, [items]);

  return (
    <div className="ui-w-full ui-text-center">
      <Marquee slides={slides} options={OPTIONS} />
    </div>
  );
};
